module.exports = __webpack_public_path__ + "img/estagio_obrigatorio.02a6f330.svg";